import { render, staticRenderFns } from "./ZurichPolicyList.vue?vue&type=template&id=2ea94596"
import script from "./ZurichPolicyList.vue?vue&type=script&lang=js"
export * from "./ZurichPolicyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports